(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // <collection-controls> — handles the Refine push-down panel / drawer.
  // Sort uses native <details>; only Refine needs JS because it's outside
  // the <details>'s natural DOM child to allow full-width push-down.
  class CollectionControls extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-refine-toggle]');
      this.panel = this.querySelector('[data-refine-panel]');
      this.scrim = this.querySelector('.limoo-refine__scrim');
      this.sortDetails = this.querySelector('.limoo-bar__sort');

      this.onToggle = this.onToggle.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onSortToggle = this.onSortToggle.bind(this);
      this.onDocClick = this.onDocClick.bind(this);

      if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
      this.querySelectorAll('[data-refine-close]').forEach((el) =>
        el.addEventListener('click', this.onClose)
      );
      // Close Sort whenever Refine opens (and vice versa)
      if (this.sortDetails) {
        this.sortDetails.addEventListener('toggle', this.onSortToggle);
      }
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
    }

    onToggle() {
      const next = !this.classList.contains('is-refine-open');
      this.setOpen(next);
    }

    onClose() {
      this.setOpen(false);
    }

    onKey(e) {
      if (e.key !== 'Escape') return;
      if (this.classList.contains('is-refine-open')) {
        this.setOpen(false);
        this.toggle?.focus();
      } else if (this.sortDetails?.open) {
        this.sortDetails.open = false;
      }
    }

    onSortToggle() {
      const isOpen = this.sortDetails.open;
      this.classList.toggle('is-sort-open', isOpen);
      // When Sort opens, close Refine
      if (isOpen && this.classList.contains('is-refine-open')) {
        this.setOpen(false);
      }
      // On mobile the sort menu is a side drawer — lock body scroll
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile) {
        document.body.style.overflow = isOpen ? 'hidden' : '';
      }
    }

    onDocClick(e) {
      // Click outside the sort dropdown closes it (native <details> doesn't)
      if (!this.sortDetails?.open) return;
      if (!this.sortDetails.contains(e.target)) {
        this.sortDetails.open = false;
      }
    }

    setOpen(open) {
      if (!this.panel || !this.toggle) return;
      // Close Sort when Refine opens
      if (open && this.sortDetails?.open) {
        this.sortDetails.open = false;
      }
      this.toggle.setAttribute('aria-expanded', String(open));
      this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        // Reveal the panel, force a reflow so the closed-state transform
        // is committed, then defer the open class to the next frame so
        // the transition definitely runs.
        this.panel.removeAttribute('hidden');
        void this.panel.offsetWidth;
        requestAnimationFrame(() => {
          this.classList.add('is-refine-open');
        });
      } else {
        this.classList.remove('is-refine-open');
        // Hide after the slide/push-out finishes so the animation plays.
        const panel = this.panel;
        const onEnd = () => {
          panel.removeEventListener('transitionend', onEnd);
          if (!this.classList.contains('is-refine-open')) {
            panel.setAttribute('hidden', '');
          }
        };
        panel.addEventListener('transitionend', onEnd, { once: true });
        // Fallback in case transitionend doesn't fire (reduced motion etc.)
        setTimeout(() => {
          panel.removeEventListener('transitionend', onEnd);
          if (!this.classList.contains('is-refine-open')) {
            panel.setAttribute('hidden', '');
          }
        }, 600);
      }
    }
  }

  if (!customElements.get('collection-controls')) {
    customElements.define('collection-controls', CollectionControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
   * <newsletter-form> — intercepts the customer-signup form submit and
   * fetches it as a background POST so the page doesn't reload (no more
   * `?customer_posted=true` jump). On success we slide the input row out
   * and fade the success line in via window.LimooMotion.
   *
   * Falls back gracefully: if anything throws (network, motion missing,
   * etc.) the form does a plain native submit and the page reloads with
   * the existing Liquid form-state branches.
   */
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.row = this.querySelector('[data-newsletter-row]');
      this.success = this.querySelector('[data-newsletter-success]');
      this.error = this.querySelector('[data-newsletter-error]');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      if (!this.form || !this.row) return;

      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    async handleSubmit(e) {
      // Let HTML5 validation run first; if invalid, native browser
      // bubble shows on the input.
      if (!this.form.checkValidity()) return;
      e.preventDefault();

      this.error.hidden = true;
      this.button.disabled = true;
      this.button.dataset.loading = 'true';

      try {
        const res = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });
        // Shopify's customer endpoint returns 200/302 on accept, 4xx on
        // reject. The redirect target is the same page with a posted
        // param — fetch follows it transparently.
        if (!res.ok) throw new Error('Subscribe failed: ' + res.status);

        await this.showSuccess();
      } catch (err) {
        console.error('[newsletter-form]', err);
        // Bail to native submit so the user still gets their signup —
        // the page reload + Liquid branches take over.
        this.form.submit();
      }
    }

    async showSuccess() {
      // Fade the input row out, swap visibility, fade the success in.
      // window.LimooMotion no-ops under prefers-reduced-motion.
      if (window.LimooMotion) {
        await window.LimooMotion.exit(this.row, { distance: -8, duration: 200 });
      }
      this.row.hidden = true;
      this.success.hidden = false;
      if (window.LimooMotion) {
        window.LimooMotion.fadeUp(this.success);
      }
    }
  }

  if (!customElements.get('newsletter-form')) {
    customElements.define('newsletter-form', NewsletterForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu drawer. Slides the overlay down from the header with a
  // proper transition, locks body scroll, and closes on link click /
  // close button / Esc.
  class MobileMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-menu-toggle]');
      this.panel = this.querySelector('[data-mobile-menu]');
      if (!this.toggle || !this.panel) return;

      this.onToggle = this.onToggle.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);

      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.body.style.overflow = '';
    }

    onToggle() {
      const open = this.toggle.getAttribute('aria-expanded') === 'true';
      this.setOpen(!open);
    }

    onClick(e) {
      if (e.target.closest('[data-menu-close]')) {
        this.setOpen(false);
        this.toggle?.focus();
        return;
      }
      if (e.target.closest('[data-menu-link]')) {
        // Close after a tick so the link still navigates
        setTimeout(() => this.setOpen(false), 0);
      }
    }

    onKey(e) {
      if (e.key !== 'Escape') return;
      if (this.toggle.getAttribute('aria-expanded') === 'true') {
        this.setOpen(false);
        this.toggle.focus();
      }
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        document.body.style.overflow = 'hidden';
        // Defer the open class to the next frame so the browser commits
        // the closed-state transform before the transition kicks in —
        // guarantees the slide-in animation actually plays.
        requestAnimationFrame(() => {
          this.classList.add('limoo-nav--menu-open');
        });
        // Focus the close button after the slide-in finishes so
        // screen-reader users land somewhere sensible.
        setTimeout(() => {
          const close = this.panel.querySelector('[data-menu-close]');
          if (close) close.focus({ preventScroll: true });
        }, 380);
      } else {
        this.classList.remove('limoo-nav--menu-open');
        document.body.style.overflow = '';
      }
    }
  }

  if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limoo-cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.body = this.querySelector('[data-drawer-body]');

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) {
          e.preventDefault();
          this.close();
        }
      });

      // Open via header cart toggle
      document.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-cart-toggle]');
        if (toggle) {
          e.preventDefault();
          this.open();
        }
      });

      // Intercept add-to-cart submits anywhere on the page
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form.matches('form[action$="/cart/add"]')) return;
        e.preventDefault();
        this.handleAddToCart(form);
      });

      // Quantity steppers + remove forms (within the drawer)
      this.addEventListener('submit', (e) => {
        const form = e.target;
        if (form.matches('[data-cart-stepper], [data-cart-remove]')) {
          e.preventDefault();
          this.handleCartChange(form, e.submitter);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dataset.state === 'open') this.close();
      });
    }

    open() {
      this.removeAttribute('hidden');
      // Force reflow + defer to next frame so the closed-state transform
      // is committed before the open class kicks in — guarantees the
      // slide-in animation actually plays.
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.dataset.state = 'open';
        document.body.classList.add('limoo-drawer-open');
        const closeBtn = this.querySelector('[data-drawer-close]');
        if (closeBtn) closeBtn.focus();
        // Notify limoo-motion to stagger cart line items in. Cheap no-op
        // when the listener is absent or prefers-reduced-motion is on.
        this.dispatchEvent(
          new CustomEvent('cart:drawer-open', { bubbles: true })
        );
      });
    }

    close() {
      this.dataset.state = 'closed';
      document.body.classList.remove('limoo-drawer-open');
      // Wait for the panel slide-out before hiding so the transition plays
      const panel = this.querySelector('.limoo-drawer__panel');
      const onEnd = () => {
        panel?.removeEventListener('transitionend', onEnd);
        if (this.dataset.state === 'closed') this.setAttribute('hidden', '');
      };
      panel?.addEventListener('transitionend', onEnd, { once: true });
      // Fallback if transitionend doesn't fire (e.g. reduced motion)
      setTimeout(() => {
        panel?.removeEventListener('transitionend', onEnd);
        if (this.dataset.state === 'closed') this.setAttribute('hidden', '');
      }, 600);
    }

    async handleAddToCart(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      const original = submitBtn ? submitBtn.innerHTML : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.loading = 'true';
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error(`Add failed: ${res.status}`);
        // Subtle scale-bump on the add button as a "yes, that worked"
        // confirmation. Brand-restrained — small range, short duration.
        if (submitBtn && window.LimooMotion) {
          window.LimooMotion.pulse(submitBtn, {
            from: 0.96,
            peak: 1.02,
            duration: 240,
          });
        }
        await this.refreshAndOpen();
      } catch (err) {
        console.error('[cart-drawer]', err);
        // Fall back: submit the form normally
        form.submit();
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.dataset.loading = 'false';
          if (original !== null) submitBtn.innerHTML = original;
        }
      }
    }

    async handleCartChange(form, submitter) {
      // Include the submit button's name/value (e.g. quantity=N from the
      // stepper buttons). Plain `new FormData(form)` doesn't pick those up.
      const data = new FormData(form, submitter);
      if (submitter && submitter.name && !data.has(submitter.name)) {
        data.set(submitter.name, submitter.value);
      }
      const payload = Object.fromEntries(data.entries());

      // Removal: slide the line out BEFORE refreshing so the user sees it
      // leave. Motion is best-effort; refresh runs even if motion is missing.
      const isRemove = form.matches('[data-cart-remove]');
      if (isRemove) {
        const line = form.closest('.limoo-cart-line');
        if (line && window.LimooMotion) {
          await window.LimooMotion.exit(line, { distance: 32, duration: 240 });
        }
      }

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(`Change failed: ${res.status}`);
        await this.refresh();
        // Also refresh the cart page if we're on it
        const cartPage = document.querySelector('[data-cart-page]');
        if (cartPage) window.location.reload();
      } catch (err) {
        console.error('[cart-drawer]', err);
        form.submit();
      }
    }

    async refresh() {
      const url = `?section_id=${this.sectionId}`;
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-drawer');
      if (!fresh) return;
      this.replaceChildren(...fresh.children);
      this.classList.toggle(
        'limoo-drawer--has-items',
        fresh.classList.contains('limoo-drawer--has-items')
      );
      this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      this.updateHeaderCount();
    }

    async refreshAndOpen() {
      await this.refresh();
      this.open();
    }

    async updateHeaderCount() {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        const count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          const prev = parseInt(el.textContent, 10) || 0;
          el.textContent = String(count);
          el.dataset.empty = count === 0 ? 'true' : 'false';
          if (count > prev) {
            // Dispatch a bubbling event so limoo-motion runs the
            // brand-tokenized scale-bump. Falls back to a CSS keyframe
            // class if Motion isn't loaded.
            el.dispatchEvent(
              new CustomEvent('cart:count-bump', { bubbles: true })
            );
            el.classList.remove('limoo-nav__cart-badge--bump');
            void el.offsetWidth;
            el.classList.add('limoo-nav__cart-badge--bump');
          }
        });
      } catch (err) {
        // Best-effort; cart count will catch up on next nav
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limoo-custom-order"] && !Shopify.designMode) return;
  try {
    
  // "Inspired by" pill — clicking the × removes the pill and its hidden
  // ref_* fields, then strips ?ref= from the URL via history.replaceState
  // so a refresh doesn't re-add it.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ref-remove]');
    if (!btn) return;
    const pill = btn.closest('[data-ref-pill]');
    if (!pill) return;
    pill.classList.add('limoo-custom__ref--removed');
    pill.querySelectorAll('[data-ref-input]').forEach((node) => node.remove());
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('ref')) {
        url.searchParams.delete('ref');
        window.history.replaceState({}, '', url);
      }
    } catch {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limoo-flavour-carousel"] && !Shopify.designMode) return;
  try {
    
  /*
   * <flavour-carousel> — the homepage flavour rotator.
   *
   * The track is one slide per flavour plus a copy of the first at the end.
   * Auto-advance only ever moves left; when it lands on the copy, the track
   * snaps back to the real first slide with the transition off, which is
   * invisible because the two slides are the same photo. That's the whole
   * trick, and it's why the loop never sweeps backwards across five slides.
   */
  class FlavourCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fc-track]');
      const slides = this.querySelectorAll('[data-fc-slide]');
      this.real = Array.from(slides).filter((s) => !s.hasAttribute('data-fc-clone'));
      this.count = this.real.length;

      // One flavour rotates nowhere, and the server already rendered its name,
      // layers and photo. Leaving early keeps the timer from ever starting.
      if (!this.track || this.count < 2) return;

      this.nameEl = this.querySelector('[data-fc-name]');
      this.layersEl = this.querySelector('[data-fc-layers]');
      this.indexEl = this.querySelector('[data-fc-index]');
      this.interval = Number(this.dataset.interval) || 4500;
      this.i = 0;
      this.hovered = false;
      this.keyFocused = false;
      // Flips once and never flips back — see takeOver().
      this.tookOver = false;

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ac = new AbortController();
      const opts = { signal: this.ac.signal };

      this.querySelector('[data-fc-prev]')?.addEventListener('click', () => this.step(-1), opts);
      this.querySelector('[data-fc-next]')?.addEventListener('click', () => this.step(1), opts);

      this.dots = Array.from(this.querySelectorAll('[data-fc-dot]'));
      this.dots.forEach((dot, n) => {
        dot.addEventListener('click', () => this.jumpTo(n), opts);
      });

      this.addEventListener('mouseenter', () => { this.hovered = true; this.settlePlayback(); }, opts);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.settlePlayback(); }, opts);

      this.addEventListener('focusin', (e) => {
        // Only a keyboard focus holds the carousel. Clicking an arrow focuses
        // it too, and an arrow press is supposed to restart the timer rather
        // than stop it, so a mouse focus must not count as a pause.
        this.keyFocused = e.target.matches(':focus-visible');
        this.settlePlayback();
      }, opts);
      this.addEventListener('focusout', () => { this.keyFocused = false; this.settlePlayback(); }, opts);

      document.addEventListener('visibilitychange', () => this.settlePlayback(), opts);
      // MediaQueryList only grew addEventListener in Safari 14. On anything
      // older the bare call throws, and it would take the rest of
      // connectedCallback down with it — including the settlePlayback() that
      // starts the rotation, so the carousel would simply sit there.
      if (typeof this.reduce.addEventListener === 'function') {
        this.reduce.addEventListener('change', () => this.settlePlayback(), opts);
      } else if (typeof this.reduce.addListener === 'function') {
        this.reduce.addListener(() => this.settlePlayback());
      }

      this.bindScroll(opts);
      this.warmSlides(opts);
      this.settlePlayback();
    }

    disconnectedCallback() {
      this.stop();
      clearTimeout(this.settleTimer);
      this.ac?.abort();
    }

    /*
     * Every slide but the first ships `loading="lazy"`, which keeps them off
     * the critical path — but they sit side by side in a track the frame
     * clips, so the browser never decides they are near the viewport and
     * never fetches them at all. The carousel would then slide an empty panel
     * into view and pop the photo in when it finally loaded.
     *
     * So once the page itself has finished loading, claim them: switch to
     * eager at low priority and decode ahead of time, so the bitmap is ready
     * before the track ever moves and the slide is pure compositing.
     */
    warmSlides(opts) {
      if (navigator.connection?.saveData) return;
      const warm = () => {
        this.querySelectorAll('[data-fc-slide] img').forEach((img) => {
          img.fetchPriority = 'low';
          if (img.loading === 'lazy') img.loading = 'eager';
          img.decode?.().catch(() => {});
        });
      };
      if (document.readyState === 'complete') warm();
      else window.addEventListener('load', warm, { once: true, ...opts });
    }

    get instant() {
      return this.reduce.matches;
    }

    get paused() {
      return (
        this.tookOver || this.hovered || this.keyFocused || document.hidden || this.instant
      );
    }

    /*
     * The first deliberate move — an arrow, a dot or a swipe — ends the
     * rotation for the rest of the visit. Someone who has started steering
     * through the flavours is reading one of them, and having the carousel
     * slide out from under them 4.5s later is the opposite of helpful. Hover
     * and focus still only pause, because neither is a choice about content.
     */
    takeOver() {
      this.tookOver = true;
      this.stop();
    }

    /* ---------- playback ---------- */

    settlePlayback() {
      if (this.paused) this.stop();
      else this.play();
    }

    play() {
      this.stop();
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    /* ---------- movement ---------- */

    /*
     * The track is a real horizontal scroller with CSS scroll-snap, not a
     * transformed strip. That is what makes a drag feel native: the photo
     * tracks the finger 1:1, carries momentum, rubber-bands at the ends and
     * settles onto a slide — all from the compositor, none of it re-derived
     * in JS. Moving it under our own control is just a scroll.
     */
    get slideWidth() {
      return this.track.clientWidth || 1;
    }

    // Smoothly, under our control.
    go(pos, animate) {
      this.selfScroll = true;
      this.track.scrollTo({
        left: pos * this.slideWidth,
        behavior: animate && !this.instant ? 'smooth' : 'auto',
      });
    }

    // Instantly and synchronously — used to teleport across the seam.
    jump(pos) {
      this.selfScroll = true;
      this.track.scrollLeft = pos * this.slideWidth;
      this.i = pos;
    }

    step(dir) {
      this.takeOver();
      if (dir > 0) this.advance();
      else this.retreat();
    }

    // Dot presses move straight to a flavour rather than stepping through the
    // ones between it and the current slide.
    jumpTo(k) {
      this.takeOver();
      if (this.i >= this.count) this.jump(this.i % this.count);
      this.go(k, true);
    }

    advance() {
      const next = this.i + 1;
      if (this.instant) {
        this.go(next % this.count, false);
        return;
      }
      // Landing on the trailing copy is fine — settled() puts the track back
      // on the real first slide, which is the same pixels, so the loop only
      // ever travels forward.
      this.go(next, true);
    }

    retreat() {
      if (this.instant) {
        this.go((this.i + this.count - 1) % this.count, false);
        return;
      }
      if (this.i === 0) {
        // Stepping back from the first flavour: teleport to the identical
        // copy at the end, then slide one frame left, so the track doesn't
        // sweep back across every slide to reach the last one.
        this.jump(this.count);
      }
      this.go(this.i - 1, true);
    }

    /*
     * The scroll position is the single source of truth for which flavour is
     * showing, so a drag the browser handled updates the name, the counter
     * and the dots exactly like an arrow press does.
     */
    bindScroll(opts) {
      let frame = 0;
      this.track.addEventListener(
        'scroll',
        () => {
          // A scroll we didn't start is the buyer taking the wheel.
          if (!this.selfScroll) this.takeOver();
          if (frame) return;
          frame = requestAnimationFrame(() => {
            frame = 0;
            const pos = Math.round(this.track.scrollLeft / this.slideWidth);
            if (pos !== this.i) {
              this.i = pos;
              this.sync();
            }
            clearTimeout(this.settleTimer);
            this.settleTimer = setTimeout(() => this.settled(), 140);
          });
        },
        { passive: true, ...opts }
      );
    }

    settled() {
      // Came to rest on the trailing copy — swap to the real first slide with
      // no animation. Identical pixels, so nothing is visible.
      if (this.i >= this.count) {
        this.jump(0);
        this.sync();
        /*
         * selfScroll deliberately stays true here. That jump fires a scroll
         * event of its own, and clearing the flag first made the handler read
         * our own teleport as a swipe: takeOver() ran and the rotation died
         * the moment it crossed the seam. Re-arm the settle instead and let
         * the branch below clear the flag once the track is back in range.
         */
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settled(), 140);
        return;
      }
      this.selfScroll = false;
    }

    sync() {
      const k = ((this.i % this.count) + this.count) % this.count;
      const slide = this.real[k];
      if (!slide) return;
      if (this.nameEl) this.nameEl.textContent = slide.dataset.fcSlideName || '';
      if (this.layersEl) this.layersEl.textContent = slide.dataset.fcSlideLayers || '';
      if (this.indexEl) {
        this.indexEl.textContent = String(k + 1).padStart(2, '0');
      }
      this.dots?.forEach((dot, n) => {
        dot.classList.toggle('is-current', n === k);
        dot.setAttribute('aria-current', n === k ? 'true' : 'false');
      });
    }

  }

  if (!customElements.get('flavour-carousel')) {
    customElements.define('flavour-carousel', FlavourCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limoo-predictive-search"]) return;
  try {
    
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-psearch-input]');
      this.results = this.querySelector('[data-psearch-results]');
      this.form = this.querySelector('form');
      this.minChars = 2;
      this.debounceMs = 200;
      this._timer = null;
      this._lastQuery = '';

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-psearch-close]')) {
          e.preventDefault();
          this.close();
        }
      });

      // Open via any [data-search-toggle] anywhere on the page
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-search-toggle]');
        if (trigger) {
          e.preventDefault();
          this.open();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dataset.state === 'open') this.close();
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.open();
        }
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.runQuery(), this.debounceMs);
      });
    }

    open() {
      this.removeAttribute('hidden');
      void this.offsetWidth;
      this.dataset.state = 'open';
      document.body.classList.add('limoo-drawer-open');
      setTimeout(() => this.input?.focus(), 50);
    }

    close() {
      this.dataset.state = 'closed';
      document.body.classList.remove('limoo-drawer-open');
      setTimeout(() => {
        if (this.dataset.state === 'closed') this.setAttribute('hidden', '');
      }, 320);
    }

    async runQuery() {
      const q = this.input.value.trim();
      if (q.length < this.minChars) {
        this.results.innerHTML = '';
        return;
      }
      if (q === this._lastQuery) return;
      this._lastQuery = q;

      const url = new URL('/search/suggest.json', window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product,article,page');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(`Search failed: ${res.status}`);
        const data = await res.json();
        this.render(data.resources?.results || {}, q);
      } catch (err) {
        console.error('[predictive-search]', err);
        this.results.innerHTML = '';
      }
    }

    render(results, q) {
      const products = results.products || [];
      const articles = results.articles || [];
      const pages = results.pages || [];

      const total = products.length + articles.length + pages.length;
      if (total === 0) {
        this.results.innerHTML =
          `<p class="limoo-psearch__none">No results for "${this.escape(q)}".</p>`;
        return;
      }

      const groups = [];
      if (products.length) groups.push(this.renderProductGroup(products));
      if (articles.length) groups.push(this.renderEditorialGroup(articles, 'Journal'));
      if (pages.length) groups.push(this.renderEditorialGroup(pages, 'Pages'));

      const viewAll = `<div class="limoo-psearch__view-all">
        <a href="/search?q=${encodeURIComponent(q)}&type=product,article,page">
          View all ${total} results →
        </a>
      </div>`;

      this.results.innerHTML = groups.join('') + viewAll;

      // Stagger the freshly-rendered result rows into view. Best-effort —
      // no-op when limoo-motion is missing or prefers-reduced-motion is on.
      if (window.LimooMotion) {
        const items = this.results.querySelectorAll(
          'li, .limoo-psearch__view-all'
        );
        window.LimooMotion.staggerIn(items, { gap: 0.025 });
      }
    }

    renderProductGroup(products) {
      const items = products.map((p) => {
        const img = p.image
          ? `<img class="limoo-psearch__product-img" src="${p.image}" alt="${this.escape(p.title)}" loading="lazy">`
          : `<div class="limoo-psearch__product-img limoo-psearch__product-img--placeholder"></div>`;
        const price = p.price
          ? `<span class="limoo-psearch__product-price">${p.price}</span>`
          : '';
        return `<li>
          <a class="limoo-psearch__product" href="${p.url}">
            ${img}
            <span class="limoo-psearch__product-title">${this.escape(p.title)}</span>
            ${price}
          </a>
        </li>`;
      }).join('');
      return `<div class="limoo-psearch__group">
        <p class="limoo-psearch__group-title">Cakes</p>
        <ul class="limoo-psearch__list">${items}</ul>
      </div>`;
    }

    renderEditorialGroup(items, label) {
      const rows = items.map((it) => {
        const date = it.published_at
          ? new Date(it.published_at).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' })
          : '—';
        const cat = it.tags && it.tags.length ? it.tags[0] : label;
        return `<li>
          <a class="limoo-psearch__editorial" href="${it.url}">
            <span class="limoo-psearch__editorial-cat">${this.escape(cat)}</span>
            <span class="limoo-psearch__editorial-title">${this.escape(it.title)}</span>
            <span class="limoo-psearch__editorial-date">${date}</span>
          </a>
        </li>`;
      }).join('');
      return `<div class="limoo-psearch__group">
        <p class="limoo-psearch__group-title">${label}</p>
        <ul class="limoo-psearch__list">${rows}</ul>
      </div>`;
    }

    escape(str) {
      return String(str).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      })[c]);
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    async connectedCallback() {
      const productId = this.dataset.productId;
      const sectionId = this.dataset.sectionId;
      const limit = this.dataset.limit || 4;
      if (!productId || !sectionId) return;

      const url = new URL('/recommendations/products', window.location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('limit', String(limit));
      url.searchParams.set('intent', 'related');

      try {
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.shopify-section') || doc.body;
        const inner = fresh.querySelector('.limoo-recs');
        if (inner) {
          this.innerHTML = '';
          this.append(inner);
        } else {
          this.innerHTML = '';
        }
      } catch (err) {
        console.warn('[product-recommendations]', err);
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  // <product-page> — gallery click-to-swap, live variant updates, sticky CTA.
  // Methods are no-ops in quote mode (no thumbs, no variant chips, no form).
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.querySelector('[data-lightbox]')?.addEventListener('close', this.afterLightboxClose);
      this.setupStickyObserver();
      this.setupGalleryObserver();
      this.syncGalleryHeight();
      window.addEventListener('resize', this.syncGalleryHeight);
      window.addEventListener('orientationchange', this.syncGalleryHeight);
      this.scrollToActiveSlide(false); // jump on first paint, no smooth
      this.watchFlavourImage();
      // After the page's own resources, never alongside them.
      if (document.readyState === 'complete') this.preloadFlavours();
      else window.addEventListener('load', () => this.preloadFlavours(), { once: true });
    }

    disconnectedCallback() {
      this._stickyObs?.disconnect();
      this._galleryObs?.disconnect();
      window.removeEventListener('resize', this.syncGalleryHeight);
      window.removeEventListener('orientationchange', this.syncGalleryHeight);
    }

    // Phone-only: measure the sticky header height so the gallery can size
    // itself to `100dvh - header` in CSS (image + thumbnails fit on screen).
    // The viewport part stays in CSS (dvh) so it tracks the browser toolbars.
    syncGalleryHeight = () => {
      if (!window.matchMedia('(max-width: 767px)').matches) {
        this.style.removeProperty('--limoo-header-h');
        return;
      }
      const header = document.querySelector('.limoo-nav');
      const headerH = header ? Math.round(header.getBoundingClientRect().height) : 64;
      this.style.setProperty('--limoo-header-h', `${headerH}px`);
    };

    onClick = (e) => {
      const variantLink = e.target.closest('[data-variant-link]');
      if (variantLink && !variantLink.matches('[aria-disabled="true"]')) {
        e.preventDefault();
        // Only the flavour options carry data-flavour-handle; size chips don't.
        // So this is the one place that knows a gallery move was asked for, and
        // it is by definition user-initiated — loadVariant() is never called
        // programmatically or on first paint, so there are no synthetic variant
        // events to filter out. Re-picking the flavour already selected is a
        // no-op (it is also absent from the menu, which shows alternates only).
        const next = variantLink.dataset.flavourHandle || '';
        this._flavourIntent =
          next && next !== (this.dataset.flavourHandle || '') ? next : null;
        if (this._flavourIntent && !this.showFlavourSlide(this._flavourIntent)) {
          // No photo for that flavour — drop the intent so the gallery keeps
          // its normal variant behaviour instead of chasing a missing slide.
          this._flavourIntent = null;
        }
        this.loadVariant(variantLink.href);
        return;
      }
      const stickyAdd = e.target.closest('[data-sticky-add]');
      if (stickyAdd && !stickyAdd.disabled) {
        const form = this.querySelector('.limoo-pdp__form');
        if (form) form.requestSubmit();
        return;
      }
      const thumb = e.target.closest('[data-thumb-id]');
      if (thumb) {
        this.scrollToSlide(thumb.dataset.thumbId);
        return;
      }
      // Inline external video (YouTube / Vimeo) — swap the poster for the iframe.
      const embedPlay = e.target.closest('[data-embed-play]');
      if (embedPlay) {
        this.loadEmbed(embedPlay.closest('[data-embed]'));
        return;
      }
      // Lightbox controls.
      if (e.target.closest('[data-lightbox-close]')) {
        this.closeLightbox();
        return;
      }
      if (e.target.closest('[data-lightbox-prev]')) {
        this.lightboxGo(-1);
        return;
      }
      if (e.target.closest('[data-lightbox-next]')) {
        this.lightboxGo(1);
        return;
      }
      const zoomImg = e.target.closest('[data-lightbox-img]');
      if (zoomImg) {
        this.toggleZoom(zoomImg, e);
        return;
      }
      const lightbox = this.querySelector('[data-lightbox]');
      if (lightbox?.open) {
        // Click on empty space (the slide padding or backdrop) closes.
        if (e.target === lightbox || e.target.closest('[data-lightbox-slide]') === e.target) {
          this.closeLightbox();
        }
        return;
      }
      // Stage image — open the lightbox at this slide.
      const zoomTrigger = e.target.closest('[data-zoom-trigger]');
      if (zoomTrigger) {
        const slide = zoomTrigger.closest('[data-slide-id]');
        this.openLightbox(slide?.dataset.slideId);
        return;
      }
      const trigger = e.target.closest('[data-serving-trigger]');
      if (trigger) {
        const wrap = trigger.closest('[data-serving-guide]');
        if (!wrap) return;
        const panel = wrap.querySelector('.limoo-serving__panel');
        const next = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', String(next));
        if (panel) {
          if (next) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
      }
    };

    onKeydown = (e) => {
      // While the lightbox is open, arrow keys page through the media set.
      const lightbox = this.querySelector('[data-lightbox]');
      if (lightbox?.open) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.lightboxGo(1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.lightboxGo(-1);
        }
        return;
      }
      // Thumbnail rail roving focus.
      if (!e.target.matches('[data-thumb-id]')) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      const thumbs = Array.from(this.querySelectorAll('[data-thumb-id]'));
      const idx = thumbs.indexOf(e.target);
      const next =
        e.key === 'ArrowRight'
          ? (idx + 1) % thumbs.length
          : (idx - 1 + thumbs.length) % thumbs.length;
      thumbs[next].focus();
      this.scrollToSlide(thumbs[next].dataset.thumbId);
    };

    /* ---------- Gallery (swipe stage + thumbs) ---------- */

    scrollToSlide(imageId, smooth = true) {
      const stage = this.querySelector('[data-gallery-stage]');
      if (!stage) return;
      const slide = stage.querySelector(`[data-slide-id="${CSS.escape(String(imageId))}"]`);
      if (!slide) return;
      const left = slide.offsetLeft - stage.offsetLeft;
      stage.scrollTo({
        left,
        behavior: smooth && !this._suppressSmooth ? 'smooth' : 'auto',
      });
      this.setActiveThumb(imageId);
    }

    scrollToActiveSlide(smooth = true) {
      const active = this.querySelector('[data-gallery-stage] [data-active="true"]');
      if (!active) return;
      this.scrollToSlide(active.dataset.slideId, smooth);
    }

    setActiveThumb(imageId) {
      this.querySelectorAll('[data-thumb-id]').forEach((t) => {
        const active = String(t.dataset.thumbId) === String(imageId);
        t.classList.toggle('limoo-pdp__thumb--active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-slide-id]').forEach((s) => {
        s.dataset.active = String(s.dataset.slideId) === String(imageId)
          ? 'true' : 'false';
      });
      this.pauseInlineMedia(imageId);
      // Autoplay (muted) only the visible slide's video; others stay paused.
      const activeSlide = this.querySelector(
        `[data-gallery-stage] [data-slide-id="${CSS.escape(String(imageId))}"]`
      );
      const video = activeSlide?.querySelector('video');
      if (video) {
        video.muted = true;
        video.play?.()?.catch(() => {});
      }
    }

    /* ---------- Flavour slide ---------- */

    // handle -> { src, srcset, thumbSrc, thumbSrcset, alt }. Static per product,
    // and the blob sits outside everything loadVariant() replaces, so one parse
    // lasts the page's life.
    get flavourMedia() {
      if (this._flavourCache) return this._flavourCache;
      const el = this.querySelector('[data-flavour-media]');
      if (!el) return (this._flavourCache = {});
      try {
        this._flavourCache = JSON.parse(el.textContent) || {};
      } catch (err) {
        console.warn('[product-page] could not parse flavour media', err);
        this._flavourCache = {};
      }
      return this._flavourCache;
    }

    // Repaint the last slide with a flavour's photo and bring it to the stage.
    // Returns false when there's nothing to show, so the caller can fall back.
    // Revealing and scrolling happen synchronously so the tap feels immediate;
    // the photo itself is swapped in by paintFlavourImage once it has decoded.
    showFlavourSlide(handle) {
      const slide = this.querySelector('[data-flavour-slide]');
      if (!slide) return false;
      const data = this.flavourMedia[handle];
      if (!data || !data.src) {
        // Fall back to the plain gallery rather than leaving a stale photo up.
        slide.hidden = true;
        this.querySelector('[data-flavour-thumb]')?.setAttribute('hidden', '');
        return false;
      }
      slide.hidden = false;
      this.querySelector('[data-flavour-thumb]')?.removeAttribute('hidden');

      // Point the placeholder at this flavour before painting. Whether it is
      // actually shown is paintFlavourImage()'s call — a warm photo needs no
      // cover, and flashing one up for a frame is the jank it exists to avoid.
      if (data.lqip) slide.style.setProperty('--flavour-lqip', `url(${data.lqip})`);

      this.paintFlavourBadges(slide, data.badges);
      this.paintFlavourImage(slide, data);

      const thumbImg = this.querySelector('[data-flavour-thumb] img');
      if (thumbImg && data.thumbSrc) {
        if (data.thumbSrcset) thumbImg.srcset = data.thumbSrcset;
        thumbImg.src = data.thumbSrc;
      }
      this.scrollToSlide('flavour');
      return true;
    }

    // Point the live <img> at the new photo immediately.
    //
    // Assigning src right away matters for correctness, not just speed: the
    // slide ships `loading="lazy"` and sits off-screen, so scrolling to it can
    // kick off a load of the PREVIOUS flavour's src that is still in flight.
    // Left alone, that load finishes and paints the wrong flavour for a beat.
    // Reassigning src aborts it.
    // This one <figure> is reused for every flavour, so its badges have to be
    // rewritten rather than re-rendered. Built as text nodes, never innerHTML:
    // the strings are merchant-entered metaobject content.
    paintFlavourBadges(slide, badges) {
      const host = slide.querySelector('[data-flavour-badges]');
      if (!host) return;
      const list = Array.isArray(badges) ? badges.filter(Boolean) : [];
      host.replaceChildren(
        ...list.map((text) => {
          const el = document.createElement('span');
          el.className = 'limoo-flavour-badge';
          el.textContent = text;
          return el;
        })
      );
      host.hidden = list.length === 0;
    }

    paintFlavourImage(slide, data) {
      const img = slide.querySelector('img');
      if (!img) return;
      // Last click wins, not last response: a slow first pick must not stomp a
      // faster second one.
      const token = {};
      this._flavourPaint = token;

      img.loading = 'eager'; // it's on screen now; lazy would only defer it
      if (data.srcset) img.srcset = data.srcset;
      img.src = data.src;
      if (data.alt) img.alt = data.alt;

      // preloadFlavours() has usually already fetched and decoded this photo,
      // in which case the assignment above is live in this very frame. Showing
      // the placeholder would then be a pure blur flash with nothing to hide,
      // so check for pixels before reaching for it.
      if (img.complete && img.naturalWidth > 0) {
        slide.dataset.flavourLoaded = 'true';
        return;
      }
      slide.dataset.flavourLoaded = 'false';
      this.settleFlavourImage(slide, img, token, data.src);
    }

    // Clear the placeholder once the photo has pixels — and make sure that
    // happens on every path, because a placeholder that never clears is worse
    // than never having one.
    //
    // Gated on the `load` event rather than `img.decode()`. decode() is the
    // nicer signal (it waits for a paintable bitmap, not just bytes) but it
    // rejects on anything unexpected — a superseding src, a detach, a decoder
    // hiccup — and a rejection is indistinguishable from a real failure, so
    // every one of them used to strand the slide mid-blur.
    settleFlavourImage(slide, img, token, src, retried) {
      const mine = () => this._flavourPaint === token;
      // Listeners from a superseded paint fire on this same element; the token
      // check makes them no-ops rather than letting them flag the wrong photo.
      this._flavourSettle?.abort();
      const ctl = (this._flavourSettle = new AbortController());
      const opts = { once: true, signal: ctl.signal };

      img.addEventListener('load', () => {
        delete img.dataset.flavourRetried; // this element gets another retry later
        if (mine()) slide.dataset.flavourLoaded = 'true';
      }, opts);

      img.addEventListener('error', () => {
        if (!mine()) return;
        // One retry: an aborted load (a detach, a flaky connection) leaves the
        // element `complete` with no pixels, and reassigning src refetches.
        if (!retried && src) {
          img.src = src;
          this.settleFlavourImage(slide, img, token, src, true);
          return;
        }
        // Genuinely broken. Drop the placeholder anyway — an empty frame reads
        // as a missing photo, where a frozen blur reads as a broken page.
        slide.dataset.flavourLoaded = 'true';
        console.warn('[product-page] flavour photo failed to load', src);
      }, opts);
    }

    // Fetch and decode every flavour photo once the page itself is done, so a
    // flavour switch is a repaint rather than a download. ~1-2MB of speculative
    // traffic (five 240-520KB photos) against an interaction the buyer is very
    // likely to make: the flavour menu is the main thing on the page.
    //
    // All of them at once, in parallel, at low priority. The previous version
    // walked them one at a time on requestIdleCallback, which on a slow idle
    // meant the photo was still unfetched when the buyer got there. Low
    // fetchPriority is what keeps this polite — it is the browser's own "after
    // everything that matters" queue, and this already runs after window load.
    //
    // Only `saveData` opts out. Connection-type sniffing used to as well, but
    // effectiveType is a rolling average that reads "3g" on plenty of
    // connections that are fine, and the result there was the worst case: a
    // long blurred wait on exactly the devices least able to absorb it.
    preloadFlavours() {
      if (navigator.connection?.saveData) return;

      const map = this.flavourMedia;
      const handles = Object.keys(map);
      if (!handles.length) return;

      // Match the live <img>'s sizes so the browser resolves srcset to the SAME
      // candidate the slide will ask for. Preloading a fixed width would warm a
      // URL that is never requested — all of the cost, none of the benefit.
      const live = this.querySelector('[data-flavour-slide] img');
      const sizes = live?.sizes || '';

      // The slide on screen is lazy and sits off the end of the carousel, so
      // its own photo is the one thing here that hasn't started loading. Let it
      // go now and the first scroll across to it has pixels waiting.
      if (live && !live.complete) live.loading = 'eager';

      // Held in a field, not a local: dropping the last reference to a decoded
      // image lets the bitmap be collected, and the decode cost comes back.
      this._flavourWarm = this._flavourWarm || [];
      for (const handle of handles) {
        const data = map[handle];
        if (!data || !data.src) continue;
        const pre = new Image();
        pre.fetchPriority = 'low';
        if (sizes) pre.sizes = sizes;
        if (data.srcset) pre.srcset = data.srcset;
        pre.src = data.src;
        // Decode off the critical path too. A cached-but-undecoded photo still
        // costs a frame the first time it is painted.
        pre.decode?.().catch(() => {});
        this._flavourWarm.push(pre);
      }
    }

    // Make sure whatever <img> is currently in the flavour slide ends up with
    // its placeholder cleared. Called on connect (the server-rendered slide is
    // lazy and off-screen, so it has no pixels yet) and after every variant
    // swap (the slide may be the server's copy rather than the kept one).
    watchFlavourImage() {
      const slide = this.querySelector('[data-flavour-slide]');
      const img = slide?.querySelector('img');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        slide.dataset.flavourLoaded = 'true';
        return;
      }
      // `complete` with no pixels means the load ended without them — aborted
      // or failed. Nothing further will fire on its own, so kick it again.
      if (img.complete) {
        const src = img.currentSrc || img.getAttribute('src');
        if (src && !img.dataset.flavourRetried) {
          img.dataset.flavourRetried = '1';
          img.src = src;
        }
      }
      slide.dataset.flavourLoaded = 'false';
      // Reuse the paint token when there is one: a click's paint may still be
      // waiting on this very image, and replacing its token would make its own
      // listeners no-ops. settleFlavourImage is idempotent for a given token.
      this._flavourPaint ||= {};
      this.settleFlavourImage(slide, img, this._flavourPaint, img.getAttribute('src'), true);
    }

    setupGalleryObserver() {
      const stage = this.querySelector('[data-gallery-stage]');
      if (!stage || !('IntersectionObserver' in window)) return;
      this._galleryObs?.disconnect();
      this._galleryObs = new IntersectionObserver(
        (entries) => {
          // Pick the entry that's most centered in the stage viewport.
          const visible = entries
            .filter((e) => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          const id = visible.target.dataset.slideId;
          if (id) this.setActiveThumb(id);
        },
        { root: stage, threshold: [0.6] }
      );
      stage.querySelectorAll('[data-slide-id]').forEach((s) =>
        this._galleryObs.observe(s)
      );
    }

    /* ---------- Media data ---------- */

    get mediaData() {
      if (this._mediaCache) return this._mediaCache;
      const el = this.querySelector('[data-product-media]');
      if (!el) return [];
      try {
        this._mediaCache = JSON.parse(el.textContent) || [];
      } catch (err) {
        console.warn('[product-page] could not parse media data', err);
        this._mediaCache = [];
      }
      return this._mediaCache;
    }

    /* ---------- Inline external video (YouTube / Vimeo) ---------- */

    loadEmbed(wrap) {
      if (!wrap || wrap.dataset.embedLoaded === 'true') return;
      const src = wrap.dataset.embedSrc;
      if (!src) return;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.className = 'limoo-pdp__hero-iframe';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.title = wrap.querySelector('img')?.alt || 'Video';
      wrap.appendChild(iframe);
      wrap.dataset.embedLoaded = 'true';
      wrap.querySelector('[data-embed-play]')?.setAttribute('hidden', '');
    }

    // Pause / tear down any inline media that isn't the active slide so video
    // and audio stop when the buyer swipes the main stage.
    pauseInlineMedia(exceptId) {
      this.querySelectorAll('[data-gallery-stage] [data-slide-id]').forEach((slide) => {
        if (String(slide.dataset.slideId) === String(exceptId)) return;
        slide.querySelectorAll('video').forEach((v) => v.pause());
        const embed = slide.querySelector('[data-embed][data-embed-loaded="true"]');
        if (embed) {
          embed.querySelector('iframe')?.remove();
          embed.dataset.embedLoaded = 'false';
          embed.querySelector('[data-embed-play]')?.removeAttribute('hidden');
        }
      });
    }

    /* ---------- Lightbox carousel ---------- */

    openLightbox(startId) {
      const lightbox = this.querySelector('[data-lightbox]');
      const track = lightbox?.querySelector('[data-lightbox-track]');
      const media = this.mediaData;
      if (!lightbox || !track || !media.length) return;

      this.buildLightbox(track, media);

      let index = media.findIndex((m) => String(m.id) === String(startId));
      if (index < 0) index = 0;
      this._lbIndex = index;

      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      document.body.style.overflow = 'hidden';

      track.addEventListener('scroll', this._onLightboxScroll, { passive: true });
      // Jump straight to the opening slide before the first paint, then sync UI.
      requestAnimationFrame(() => {
        this.lightboxTo(index, false);
        this.updateLightboxUI();
      });
    }

    buildLightbox(track, media) {
      if (track.dataset.built === 'true') return;
      const frag = document.createDocumentFragment();
      media.forEach((m, i) => {
        const slide = document.createElement('div');
        slide.className = 'limoo-lightbox__slide';
        slide.dataset.lightboxSlide = '';
        slide.dataset.index = String(i);

        if (m.type === 'video' && Array.isArray(m.sources) && m.sources.length) {
          const video = document.createElement('video');
          video.className = 'limoo-lightbox__video';
          video.controls = true;
          video.playsInline = true;
          video.preload = 'none';
          if (m.src) video.poster = m.src;
          m.sources.forEach((s) => {
            const source = document.createElement('source');
            source.src = s.url;
            if (s.mimeType) source.type = s.mimeType;
            video.appendChild(source);
          });
          slide.appendChild(video);
        } else if (m.type === 'external_video' && m.embed) {
          slide.classList.add('limoo-lightbox__slide--embed');
          slide.dataset.embed = '';
          slide.dataset.embedSrc = m.embed;
          const img = document.createElement('img');
          img.className = 'limoo-lightbox__img';
          img.src = m.src;
          img.alt = m.alt || '';
          slide.appendChild(img);
        } else {
          const img = document.createElement('img');
          img.className = 'limoo-lightbox__img';
          img.dataset.lightboxImg = '';
          img.src = m.src;
          if (m.srcset) img.srcset = m.srcset;
          img.sizes = '100vw';
          img.alt = m.alt || '';
          img.dataset.zoom = m.zoom || m.src;
          img.loading = 'lazy';
          img.decoding = 'async';
          slide.appendChild(img);
        }
        frag.appendChild(slide);
      });
      track.innerHTML = '';
      track.appendChild(frag);
      track.dataset.built = 'true';

      const single = media.length < 2;
      this.querySelector('[data-lightbox-prev]')?.toggleAttribute('hidden', single);
      this.querySelector('[data-lightbox-next]')?.toggleAttribute('hidden', single);
    }

    lightboxTo(index, smooth = true) {
      const track = this.querySelector('[data-lightbox-track]');
      if (!track) return;
      const count = track.children.length;
      if (!count) return;
      const clamped = Math.max(0, Math.min(index, count - 1));
      this._lbIndex = clamped;
      this.resetZoom();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Slides are each full track width, so scrollLeft = index * width.
      track.scrollTo({
        left: clamped * track.clientWidth,
        behavior: smooth && !reduce ? 'smooth' : 'auto',
      });
      this.updateLightboxUI();
    }

    lightboxGo(delta) {
      this.lightboxTo((this._lbIndex || 0) + delta);
    }

    _onLightboxScroll = () => {
      if (this._lbScrollRaf) return;
      this._lbScrollRaf = requestAnimationFrame(() => {
        this._lbScrollRaf = null;
        const track = this.querySelector('[data-lightbox-track]');
        if (!track) return;
        const idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (idx !== this._lbIndex) {
          this._lbIndex = idx;
          this.resetZoom();
          this.updateLightboxUI();
        }
      });
    };

    updateLightboxUI() {
      const total = this.mediaData.length;
      const idx = this._lbIndex || 0;

      const counter = this.querySelector('[data-lightbox-counter]');
      if (counter) counter.textContent = total > 1 ? `${idx + 1} / ${total}` : '';

      const prev = this.querySelector('[data-lightbox-prev]');
      const next = this.querySelector('[data-lightbox-next]');
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= total - 1;

      const track = this.querySelector('[data-lightbox-track]');
      if (!track) return;
      Array.from(track.children).forEach((slide, i) => {
        const active = i === idx;
        if (!active) slide.querySelectorAll('video').forEach((v) => v.pause());
        if (slide.dataset.embed !== undefined) {
          if (active && slide.dataset.embedLoaded !== 'true') {
            this.loadEmbed(slide);
          } else if (!active && slide.dataset.embedLoaded === 'true') {
            slide.querySelector('iframe')?.remove();
            slide.dataset.embedLoaded = 'false';
          }
        }
      });
    }

    /* ---------- Click-to-zoom (mouse / trackpad only; touch uses pinch) ---------- */

    toggleZoom(img, e) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (img.classList.contains('is-zoomed')) {
        this.resetZoom();
        return;
      }
      img.classList.add('is-zoomed');
      if (img.dataset.zoom && img.src !== img.dataset.zoom) img.src = img.dataset.zoom;
      this._positionZoom(img, e);
      this.querySelector('[data-lightbox-track]')?.classList.add('is-zoom-locked');
      img.addEventListener('pointermove', this._zoomMove);
      this._zoomImg = img;
    }

    _positionZoom(img, e) {
      const rect = img.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
      img.style.transformOrigin = `${x}% ${y}%`;
    }

    _zoomMove = (e) => {
      if (this._zoomImg) this._positionZoom(this._zoomImg, e);
    };

    resetZoom() {
      const img = this._zoomImg;
      if (img) {
        img.classList.remove('is-zoomed');
        img.style.transformOrigin = '';
        img.removeEventListener('pointermove', this._zoomMove);
      }
      this.querySelector('[data-lightbox-track]')?.classList.remove('is-zoom-locked');
      this._zoomImg = null;
    }

    closeLightbox() {
      const lightbox = this.querySelector('[data-lightbox]');
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close(); // fires 'close' → afterLightboxClose
      else {
        lightbox.removeAttribute('open');
        this.afterLightboxClose();
      }
    }

    // Cleanup runs on the dialog 'close' event so Esc-to-close is covered too.
    afterLightboxClose = () => {
      const track = this.querySelector('[data-lightbox-track]');
      this.resetZoom();
      track?.querySelectorAll('video').forEach((v) => v.pause());
      track?.querySelectorAll('iframe').forEach((f) => f.remove());
      track?.querySelectorAll('[data-embed]').forEach((s) => { s.dataset.embedLoaded = 'false'; });
      track?.removeEventListener('scroll', this._onLightboxScroll);
      document.body.style.overflow = '';
      // Leave the inline stage where the buyer ended up in the lightbox.
      const landed = this.mediaData[this._lbIndex || 0];
      if (landed) this.scrollToSlide(landed.id, false);
    };

    /* ---------- Variant fetch via Section Rendering API ---------- */

    async loadVariant(href) {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) {
        window.location.href = href;
        return;
      }
      const url = new URL(href, window.location.origin);
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', sectionId);
      try {
        this.classList.add('limoo-pdp--loading');
        const res = await fetch(fetchUrl);
        if (!res.ok) throw new Error('Status ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newInfo = doc.querySelector('[data-info-panel]');
        const newStage = doc.querySelector('[data-gallery-stage]');
        const newThumbs = doc.querySelector('[data-gallery-thumbs]');
        const newSticky = doc.querySelector('[data-sticky-cta]');
        const newMediaData = doc.querySelector('[data-product-media]');

        if (newInfo) this.querySelector('[data-info-panel]').innerHTML = newInfo.innerHTML;
        // The host's own attributes aren't part of the replaced markup, so carry
        // the new flavour across by hand or the next click compares against a
        // stale handle and reads as a no-op.
        const newRoot = doc.querySelector('product-page');
        if (newRoot && newRoot.dataset.flavourHandle !== undefined) {
          this.dataset.flavourHandle = newRoot.dataset.flavourHandle;
        }

        if (newStage) {
          const stage = this.querySelector('[data-gallery-stage]');
          // What the buyer is looking at right now. The scroll observer keeps
          // data-active in step with the stage, so this is the viewed slide,
          // not merely the one the server opened on.
          const viewedId = stage.querySelector('[data-active="true"]')?.dataset.slideId;
          const prevServerId = stage.dataset.initialActive;
          const nextServerId = newStage.dataset.initialActive;

          // The flavour slide is client-owned: showFlavourSlide() has already
          // pointed it at the new flavour and its photo may still be in flight.
          // Re-parsing the server's copy would throw that element away and make
          // the browser fetch and decode the same bytes again — a second chance
          // to flash — so carry the live nodes across the swap instead, unless
          // the new variant's flavour has no photo, in which case the server
          // omits the slide and the kept node should go with it.
          //
          // The kept <img> is detached for a moment here, between the innerHTML
          // write and replaceWith(). Chrome keeps an in-flight load running
          // across that (checked: swap at 430ms into a stalled 5s load, photo
          // still arrived), so there is nothing to work around.
          const keptSlide = stage.querySelector('[data-flavour-slide]');
          const thumbs = this.querySelector('[data-gallery-thumbs]');
          const keptThumb = thumbs?.querySelector('[data-flavour-thumb]');
          const serverHasFlavour = !!newStage.querySelector('[data-flavour-slide]');

          stage.innerHTML = newStage.innerHTML;
          if (nextServerId !== undefined) stage.dataset.initialActive = nextServerId;
          if (thumbs && newThumbs) thumbs.innerHTML = newThumbs.innerHTML;

          if (serverHasFlavour && keptSlide) {
            stage.querySelector('[data-flavour-slide]')?.replaceWith(keptSlide);
            if (thumbs && keptThumb) {
              thumbs.querySelector('[data-flavour-thumb]')?.replaceWith(keptThumb);
            }
          }
          // Whichever slide ended up on the stage — the kept node or the
          // server's own copy — make sure something will clear its placeholder.
          this.watchFlavourImage();
          this.setupGalleryObserver();

          // Where to land, in order of precedence:
          //   1. the flavour slide, when the buyer just changed flavour;
          //   2. the server's slide, when the new variant brought its own
          //      featured media (so a variant image still wins);
          //   3. otherwise stay put — changing size must not yank the gallery
          //      away from whatever the buyer was looking at.
          let targetId = null;
          if (this._flavourIntent && stage.querySelector('[data-flavour-slide]')) {
            targetId = 'flavour';
          } else if (nextServerId && nextServerId !== prevServerId) {
            targetId = nextServerId;
          } else if (
            viewedId &&
            stage.querySelector(`[data-slide-id="${CSS.escape(String(viewedId))}"]`)
          ) {
            targetId = viewedId;
          }

          this._suppressSmooth = true;
          if (targetId) {
            this.scrollToSlide(targetId, false);
          } else {
            this.scrollToActiveSlide(false);
          }
          this._suppressSmooth = false;
        }
        if (newSticky) this.querySelector('[data-sticky-cta]').innerHTML = newSticky.innerHTML;
        if (newMediaData) {
          this.querySelector('[data-product-media]').textContent = newMediaData.textContent;
          // Media set may have changed — drop caches so the lightbox rebuilds.
          this._mediaCache = null;
          const track = this.querySelector('[data-lightbox-track]');
          if (track) track.dataset.built = 'false';
        }

        window.history.replaceState({}, '', url);
        this.setupStickyObserver();
      } catch (err) {
        console.warn('[product-page] variant fetch failed; falling back to navigation', err);
        window.location.href = href;
      } finally {
        this.classList.remove('limoo-pdp--loading');
        this._flavourIntent = null;
      }
    }

    setupStickyObserver() {
      const mainCta = this.querySelector('[data-main-add]');
      const sticky = this.querySelector('[data-sticky-cta]');
      if (!mainCta || !sticky || !('IntersectionObserver' in window)) return;
      this._stickyObs?.disconnect();
      this._stickyObs = new IntersectionObserver(
        ([entry]) => {
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('limoo-pdp__sticky--visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        },
        { rootMargin: '0px' }
      );
      this._stickyObs.observe(mainCta);
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();
})();
